'use strict';

(function() {
	angular.module('onboarding.internaladmin')
		.directive('cobAdminCarrierList', cobAdminCarrierList);

	cobAdminCarrierList.$inject = [
		'subjectObserverMessagesService', 'observerService', 'internalAdminService', 'sessionService', '$state',
		'Upload', 'validationService'
	];

	var subjectObserverMessagesService,
		observerService,
		internalAdminService,
		subjectMessages,
		observerMessages,
		sessionService,
		state,
		validationService,
		ngFileUpload,
		reloadAjax;

	function cobAdminCarrierList(_subjectObserverMessagesService_,
		_observerService_,
		_internalAdminService_,
		_sessionService_,
		_state_,
		_ngFileUpload_,
		_validationService_) {
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		internalAdminService = _internalAdminService_;
		sessionService = _sessionService_;
		state = _state_;
		ngFileUpload = _ngFileUpload_;
		validationService = _validationService_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/internaladmin/cobAdminCarrierList.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.carriers = [];
			scope.sortReverse = true;
			scope.rowCount = 100;
			scope.currentRow = 0;
			scope.totalRows = -1;
			scope.ajaxIsRunning = false;
			scope.sortType = 'legalName';
			scope.searchType = 'docketNumber';
			scope.searchInputPlaceholder = '';
			scope.isSearch = false;
			scope.showTinErrorModal = false;
			scope.searchClicked = searchClicked;
			scope.searchTypeChanged = searchTypeChanged;
			scope.searchInputKeyPress = searchInputKeyPress;
			scope.searchInputChange = searchInputChange;
			scope.setTinText = setTinText;
			scope.sortClicked = sortClicked;
			scope.upload = upload;
			scope.closeTinErrorModal = closeTinErrorModal;
			scope.clearSearchClicked = clearSearchClicked;
			scope.closeTinStatusModal = closeTinStatusModal;
			scope.tinStatusFilter = tinStatusFilter;
			scope.tinStatusChange = tinStatusChange;
			scope.openTinStatusModal = openTinStatusModal;
			scope.carrierImpersonate = carrierImpersonate;
			scope.setStatusFilter = setStatusFilter;
			scope.tinStatusRejectionCodeInfo = {
				0 : 'TIN and Name combination matches IRS Record',
				1 : 'TIN was missing or TIN not 9-digit numeric',
				2 :'TIN entered is not currently issued',
				3 : 'TIN and Name combination does not match IRS record',
				4: 'Invalid TIN Matching request',
				5: 'Duplicate TIN Matching request',
				6: 'TIN and Name combination matches IRS SSN records',
				7: 'TIN and Name combination matches IRS EIN records',
				8: 'TIN and Name combination matches IRS SSN and EIN records'
			};
			resetModalWindowData();

			if (!scope.tinResultsFileErrors) {
				scope.tinResultsFileErrors = {};
			}

			registerEventHandlers();
			document.title = 'Admin - Carriers';
			searchTypeChanged();
			setStatusFilter('Pending');
		}

		function registerEventHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_SCROLL_MESSAGE, handler: getSearchData }
				]);
		}

		function getCarriers() {

			if (scope.ajaxIsRunning) {
				return;
			}

			scope.ajaxIsRunning = true;
			setTimeout(function() {
				observerService.sendMessageToSubject(scope,
					subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
			},
			1);

			internalAdminService.getCarriers()
				.then(function(response) {
					scope.carriers = response.data.carriers;
					scope.totalRows = response.data.totalRowsAvailable;
				})
				.finally(function() {
					scope.ajaxIsRunning = false;
					observerService.sendMessageToSubject(scope,
						subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
				});

			return;
		}

		function sortClicked(sortType) {
			if (scope.sortType === sortType) {
				scope.sortReverse = !scope.sortReverse;

				return;
			} else {
				scope.sortType = sortType;
				scope.sortReverse = false;
			}
		}

		function searchClicked() {
			if (validateSearchInput()) {
				clearFilter();
				clearSearch();
				getSearchData();
			}
		}

		function getSearchData() {
			if (scope.ajaxIsRunning || !scope.isSearch) {
				return;
			}

			if (scope.currentRow <= scope.totalRows) {
				scope.ajaxIsRunning = true;
				setTimeout(function() {
					observerService.sendMessageToSubject(scope,
						subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
				},
				1);

				internalAdminService.searchCarriers(scope.filterType || scope.searchType,
					scope.searchValue || scope.filterValue,
					scope.currentRow,
					scope.rowCount,
					scope.currentRow === 0)
					.then(function(response) {
						if (scope.currentRow === 0) {
							scope.totalRows = response.data.totalRowsAvailable;
						}

						scope.currentRow += scope.rowCount;

						var length = response.data.carriers.length;
						for (var i = 0; i < length; i++) {
							if (response.data.carriers[i].intrastateState)
								response.data.carriers[i].intrastate = response.data.carriers[i].intrastateState + '/' + response.data.carriers[i].intrastateCode;
							scope.carriers.push(response.data.carriers[i]);
						}
					})
					.catch(function(e) {
						console.log(e);
					})
					.finally(function() {
						scope.ajaxIsRunning = false;
						observerService
							.sendMessageToSubject(scope,
								subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
						if (reloadAjax) {
							reloadAjax = false;
							scope.currentRow = 0;
							scope.totalRows = 0;
							scope.carriers = [];
							getSearchData();
						}
					});
			}

			return;
		}

		function searchTypeChanged() {
			scope.searchValue = '';
			scope.searchInputError = '';
			switch (scope.searchType) {
			case 'company':
				scope.searchInputType = 'text';
				scope.searchInputPlaceholder = 'e.g. Sample Company';
				break;
			case 'dotNumber':
				scope.searchInputType = 'text';
				scope.searchInputPlaceholder = 'e.g. 1234567';
				break;
			case 'docketNumber':
				scope.searchInputType = 'text';
				scope.searchInputPlaceholder = 'e.g. 123456';
				break;
			case 'timeFrame':
				scope.searchInputType = 'text';
				scope.searchInputPlaceholder = 'e.g. mm/dd/yy';
				break;
			case 'intrastateNumber':
				scope.searchInputType = 'text';
				scope.searchInputPlaceholder = 'e.g. 001122333A';
				break;
			case 'scacCode':
				scope.searchInputType = 'text';
				scope.searchInputPlaceholder = 'e.g. ABCD';
				break;
			case 'email':
				scope.searchInputType = 'text';
				scope.searchInputPlaceholder = 'e.g. john.smith@dat.com';
				break;
			case 'guid':
				scope.searchInputType = 'guid';
				scope.searchInputPlaceholder = 'e.g. DECA1A5E-3147-483D-BC7E-E5F601A205F9';
				break;
			}
		}

		function validateSearchInput() {
			var errorText = 'Please input a valid search value';
			switch (scope.searchType) {
			case 'company':
				if (scope.searchValue.length > 155 || scope.searchValue.length === 0) {
					scope.searchInputError = errorText;
				} else {
					scope.searchInputError = '';
				}
				break;
			case 'guid':
				if (scope.searchValue.length > 50 || scope.searchValue.length === 0) {
					scope.searchInputError = errorText;
				} else {
					scope.searchInputError = '';
				}
				break;
			case 'dotNumber':
				if (/^[0-9]{1,9}$/.test(scope.searchValue)) {
					scope.searchInputError = '';
				} else {
					scope.searchInputError = errorText;
				}
				break;
			case 'docketNumber':
				if (/^[0-9]{1,9}$/.test(scope.searchValue)) {
					scope.searchInputError = '';
				} else {
					scope.searchInputError = errorText;
				}
				break;
			case 'intrastateNumber':
				if (/^[a-zA-Z0-9-]{1,15}$/.test(scope.searchValue)) {
					scope.searchInputError = '';
				} else {
					scope.searchInputError = errorText;
				}
				break;
			case 'scacCode':
				if (/^[a-zA-Z]{1,4}$/.test(scope.searchValue)) {
					scope.searchInputError = '';
				} else {
					scope.searchInputError = errorText;
				}
				break;
			case 'email':
				if (validationService.isValidEmail(scope.searchValue)) {
					scope.searchInputError = '';
				} else {
					scope.searchInputError = 'Please enter a valid email';
				}
				break;
			}

			return !scope.searchInputError;
		}

		function searchInputChange() {
			switch (scope.searchType) {
			case 'company':
				scope.searchValue = scope.searchValue.substring(0, 155);
				break;
			case 'guid':
				scope.searchValue = scope.searchValue.substring(0, 50);
				break;
			case 'dotNumber':
				scope.searchValue = scope.searchValue.substring(0, 9);
				break;
			case 'docketNumber':
				scope.searchValue = scope.searchValue.substring(0, 9);
				break;
			case 'intrastateNumber':
				scope.searchValue = scope.searchValue.substring(0, 15);
				break;
			case 'scacCode':
				scope.searchValue = scope.searchValue.substring(0, 4);
				break;
			}
		}

		function searchInputKeyPress(event) {
			var charCode = (event.which) ? event.which : event.keyCode;
			if (charCode === 13) { // on Enter
				searchClicked();
				event.preventDefault();

				return;
			}
			switch (charCode) {
			case 8: //backspace
			case 35: //end
			case 36: //home
			case 37: //left arrow
			case 39: //right arrow
			case 46: //delete
				return;
			}

			var key = String.fromCharCode(charCode);

			switch (scope.searchType) {
			case 'company':
			case 'email':
				break;
			case 'dotNumber':
			case 'docketNumber':
				if (!/^[0-9]$/.test(key)) {
					event.preventDefault();
				}
				break;
			case 'intrastateNumber':
				if (!/^[a-zA-Z0-9-]$/.test(key)) {
					event.preventDefault();
				}
				break;
			case 'scacCode':
				if (!/^[a-zA-Z]$/.test(key)) {
					event.preventDefault();
				}
				break;
			}
		}

		function setTinText(input) {
			if (input === 'New') {
				return 'Canadian';
			}

			return input;
		}

		function saveTinResults() {
			if (scope.tinResultsFileErrors.file) {
				return;
			}

			var regex = /(?:\.([^.]+))?$/;

			var uploadTinResultsRequest = {
				fileContent: scope.tinResultsFile.base64,
				mimeType: scope.tinResultsFile.filetype,
				fileName: scope.tinResultsFile.filename,
				fileExtension: regex.exec(scope.tinResultsFile.filename)[1]
			};

			internalAdminService.processTinFile(uploadTinResultsRequest)
				.then(function() {
					getCarriers();
				})
				.catch(function() {
					scope.showTinErrorModal = true;
				});
		}

		function validateTinResults() {
			var errors = [];
			var validMimeTypes = [
				'text/plain'
			];

			var validFileExtensions = ['txt'];


			if (scope.tinResultsFile.filesize >= 15728640) {
				errors.push('File size must be less than 15mb');
			}


			if (scope.tinResultsFile.filetype !== '') {
				if (validMimeTypes.indexOf(scope.tinResultsFile.filetype) === -1) {
					errors.push('Select a valid file type');
				}
			} else {
				var regex = /(?:\.([^.]+))?$/;
				var extension = regex.exec(scope.tinResultsFile.filename);

				if (validFileExtensions.indexOf(extension[1]) === -1) {
					errors.push('Select a valid file type');
				} else {
					switch (extension[1]) {
					case 'txt':
						scope.contract.tinResultsFile.filetype = 'text/palin';
						break;
					}
				}
			}

			if (errors.length > 0) {
				scope.tinResultsFileErrors.file = true;
			} else {
				scope.tinResultsFileErrors.file = false;
			}

			saveTinResults();
		}

		function upload(files) {
			if (files && files.length === 1) {
				var file = files[0];

				scope.tinResultsFile.filetype = file.type;
				scope.tinResultsFile.filename = file.name;
				scope.tinResultsFile.filesize = file.size;

				ngFileUpload.base64DataUrl(file, false)
					.then(function(url) {
						scope.tinResultsFile.base64 = url.split(',')[1];
						validateTinResults();
					});
			}
		}

		function clearSearchClicked() {
			setStatusFilter('Pending');
			getCarriers();
			scope.isSearch = false;
			scope.searchValue = '';
		}

		function closeTinErrorModal() {
			scope.showTinErrorModal = false;
		}

		function closeTinStatusModal() {
			scope.showTinStatusModal = false;
			updateCarriersList();
			resetModalWindowData();
		}

		function resetModalWindowData() {
			scope.modalWindowData = {};
		}

		function updateCarriersList() {
			if (scope.modalWindowData.carrierTinStatus !== scope.carrier.tinStatus && scope.filterValue !== 'All') {
				scope.carriers.splice(scope.modalWindowData.carrierIndex, 1);
				scope.carriers = scope.carriers.slice();
			}
		}

		function openTinStatusModal(index, carrier) {
			scope.carrier = carrier;
			scope.modalWindowData = createModalWindowData(index, carrier.tinStatus);
			scope.showTinStatusModal = true;
		}

		function createModalWindowData(index, tinStatus) {
			return {
				carrierIndex: index,
				carrierTinStatus: tinStatus
			};
		}

		function tinStatusChange() {
			var tinStatusChangeRequest = {
				legalName: scope.carrier.legalName,
				tin: scope.carrier.tin,
				tinStatus: scope.carrier.tinStatus
			};

			if (scope.carrier.taxLegalName) {
				tinStatusChangeRequest.legalName = scope.carrier.taxLegalName;
			}

			internalAdminService.updateTinStatus(tinStatusChangeRequest)
				.then(function() {
				// 	getCarriers();
				});
		}

		function tinStatusFilter(carrier) {
			if (carrier.tinStatus == 'NotValid')
				return 'Invalid';

			return carrier.tinStatus;
		}

		function carrierImpersonate(carrier) {
			sessionService.setCarrierImpersonated(carrier.carrierId,
				carrier.legalName,
				carrier.dotNumber,
				carrier.intrastateCode,
				carrier.intrastateState);
		}

		function setStatusFilter(status) {
			scope.searchType = 'docketNumber';
			searchTypeChanged();
			clearSearch();

			scope.filterType = 'tinStatus';
			scope.filterValue = status;
			
			if (scope.ajaxIsRunning) {
				reloadAjax = true;
			}
			getSearchData();
		}

		function clearFilter() {
			scope.filterType = '';
			scope.filterValue = '';
		}

		function clearSearch() {
			scope.carriers = [];
			scope.searchInputError = '';
			scope.currentRow = 0;
			scope.totalRows = 0;
			scope.isSearch = true;
		}
	}
})();
